/**
 * Test if Admin can book for themselves vs others
 */

import { createBooking } from '../services/bookingService';

export async function testAdminSelfBooking() {
  const COURSE_ID = '045ef510-0d3d-41f7-808e-e75a77cb765c';
  
  console.log('🔍 TESTING ADMIN SELF vs OTHER BOOKING');
  console.log('=' .repeat(50));
  
  try {
    // Test 1: Admin booking for THEMSELVES (like a Student would)
    console.log('\nTest 1: Admin booking for SELF (no studentEmail)...');
    try {
      const selfBooking = await createBooking({
        courseId: COURSE_ID,
        // NO studentEmail - booking for self
        paymentType: { type: 'deposit' }
      });
      console.log('✅ SELF BOOKING WORKED!', selfBooking);
    } catch (err) {
      console.log('❌ Self booking failed:', err.message || err);
    }
    
    // Test 2: Admin booking for ANOTHER person
    console.log('\nTest 2: Admin booking for ANOTHER person...');
    try {
      const otherBooking = await createBooking({
        courseId: COURSE_ID,
        studentEmail: `test_${Date.now()}@test.com`, // Different email
        studentName: 'Test Student',
        paymentType: { type: 'deposit' }
      });
      console.log('✅ OTHER BOOKING WORKED!', otherBooking);
    } catch (err) {
      console.log('❌ Other booking failed:', err.message || err);
    }
    
    // Test 3: Admin booking with app-style data for self
    console.log('\nTest 3: Admin with full app-style data (self)...');
    try {
      const appStyleBooking = await createBooking({
        courseId: COURSE_ID,
        amount: 99900,
        paymentType: {
          id: 'standard',
          name: 'Standard Payment',
          type: 'full',
          amount: 99900
        },
        status: 'slot_reserved',
        paymentStatus: 'pending',
        formStatus: 'not_started',
        studentEmail: null, // null = booking for self
        createdAt: new Date().toISOString(),
        expiresAt: new Date(Date.now() + 300000).toISOString()
      });
      console.log('✅ APP-STYLE SELF BOOKING WORKED!', appStyleBooking);
    } catch (err) {
      console.log('❌ App-style self booking failed:', err.message || err);
    }
    
  } catch (error) {
    console.error('Test failed:', error);
  }
}

window.testAdminSelfBooking = testAdminSelfBooking;